// GlidepathDisclaimer.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';
//import './GlidepathDisclaimer.css';

const GlidepathDisclaimer = ({ GlidepathDisclaimerLabels = {}, fundData}) => {
  const { t } = useTranslation();
  return (
    <div className="l-container">
        <div className="l-grid__row">
            {t('asOfDateLabel')} {fundData?.AsOfDate}
        </div>
        {GlidepathDisclaimerLabels?.disclaimer && (
          <div className="l-grid__row">
              <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(GlidepathDisclaimerLabels.disclaimer) }}></p>
          </div>
        )}
    </div>
  )
};
export default GlidepathDisclaimer;